import { __awaiter, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useCsCfgObject, useCsConfigurationApi, } from "@plansoft-configuration-renderer/framework";
import { ButtonUi } from "./ButtonUi";
const DEFAULT_COMPONENT_MAPPING = {
    ButtonUi,
};
export function UserDefinedFunctionButton(props) {
    const [disabled, setDisabled] = useState(false);
    const { functionName, input, components: Components = DEFAULT_COMPONENT_MAPPING } = props, otherProps = __rest(props, ["functionName", "input", "components"]);
    const { invokeUserDefinedFunction } = useCsConfigurationApi();
    const { path } = useCsCfgObject();
    function handleClick() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setDisabled(true);
                const output = yield invokeUserDefinedFunction({
                    name: functionName,
                    input,
                    path,
                });
                console.log(`invokeUserDefinedFunction "${functionName}":`, {
                    input,
                    output,
                });
            }
            catch (err) {
                console.log(err);
            }
            finally {
                setDisabled(false);
            }
        });
    }
    return (_jsx(Components.ButtonUi, Object.assign({}, otherProps, { onClick: handleClick, disabled: disabled })));
}
//# sourceMappingURL=UserDefinedFunctionButton.js.map